export const getCardNumbersFormat = (
  bin: string,
  last_four: string,
): string => {
  let cardNumber = "";

  if (bin) {
    cardNumber = `${bin.slice(0, 4)} ${bin.slice(4, 6)}`;
  } else {
    cardNumber += "**** **";
  }

  cardNumber += "** ****";

  if (last_four) {
    cardNumber += " " + last_four;
  } else {
    cardNumber += " " + "****";
  }

  return cardNumber;
};
